<template>
	<svg
		:width="size"
		:height="size"
		viewBox="0 0 20 20"
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		role="img"
		:aria-hidden="ariaHidden"
	>
		<path
			d="M12.1133 18.0716C12.145 18.1505 12.2 18.2179 12.2711 18.2646C12.3421 18.3113 12.4257 18.3352 12.5107 18.333C12.5957 18.3308 12.678 18.3027 12.7465 18.2524C12.8151 18.2021 12.8666 18.1321 12.8942 18.0516L18.3108 2.2183C18.3375 2.14446 18.3426 2.06455 18.3255 1.98793C18.3084 1.9113 18.2699 1.84113 18.2144 1.78561C18.1588 1.7301 18.0887 1.69154 18.012 1.67446C17.9354 1.65737 17.8555 1.66246 17.7817 1.68913L1.94834 7.1058C1.86792 7.13338 1.79787 7.1849 1.74757 7.25344C1.69728 7.32199 1.66915 7.40428 1.66698 7.48926C1.6648 7.57425 1.68867 7.65787 1.73539 7.7289C1.78211 7.79993 1.84944 7.85497 1.92834 7.88663L8.53668 10.5366C8.74558 10.6203 8.93539 10.7453 9.09465 10.9043C9.25391 11.0633 9.37933 11.2529 9.46334 11.4616L12.1133 18.0716Z"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M18.2117 1.78906L9.095 10.9049"
			:stroke="computedStroke"
			:stroke-width="strokeWidth"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: 'IconPaperPlane',
	props: {
		size: {
			type: [Number, String],
			default: 20
		},
		color: {
			type: String,
			default: 'currentColor'
		},
		filled: {
			type: Boolean,
			default: true
		},
		strokeWidth: {
			type: [Number, String],
			default: 1.65
		},
		ariaHidden: {
			type: Boolean,
			default: true
		}
	},
	computed: {
		computedFill() {
			return this.filled ? this.color : 'none'
		},
		computedStroke() {
			return this.color
		}
	}
}
</script>
